module.exports = __webpack_public_path__ + "media/images/front/founders/bane-bbc15285449c564099676b0454b89706.jpg";